"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Divider_1 = __importDefault(require("@material-ui/core/Divider"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var Business = __importStar(require("../../../ui/business"));
var cell_1 = require("../../../ui/cell");
var layout_1 = require("../../../ui/layout");
var link_1 = __importDefault(require("../../../ui/link"));
var button_default_1 = __importDefault(require("../../../ui/button/button-default"));
var utils_1 = require("../../../utils");
var request_1 = __importDefault(require("./request"));
var email_1 = __importDefault(require("./email"));
var workflow_1 = __importDefault(require("./workflow"));
var refresh_assets_1 = __importDefault(require("./refresh-assets"));
var useStyles = utils_1.makeStyles(function (theme) { return ({
    link: {
        marginBottom: theme.spacing(2)
    },
    sendEmailButtonContainer: {
        textAlign: 'right'
    },
    divider: {
        margin: theme.spacing(2, 0)
    },
    buttonContainer: {
        marginTop: theme.spacing(2)
    }
}); });
var Dashboard = function (_a) {
    var _b = _a.disableAssetsRefresh, disableAssetsRefresh = _b === void 0 ? false : _b, props = __rest(_a, ["disableAssetsRefresh"]);
    var location = react_router_dom_1.useLocation();
    var classes = useStyles();
    var sendEmailUrl = props.urlPrefix + "/send-email";
    return (react_1["default"].createElement(layout_1.Simple, { title: "Dashboard" },
        react_1["default"].createElement(cell_1.Layout, null,
            react_1["default"].createElement(cell_1.Cell, { title: "Refresh" },
                react_1["default"].createElement("div", null,
                    react_1["default"].createElement(Business.I18nRefresh, { label: "Refresh Translations", withBackend: props.withBackend })),
                react_1["default"].createElement(Divider_1["default"], { className: classes.divider }),
                react_1["default"].createElement("div", { className: classes.buttonContainer },
                    react_1["default"].createElement(refresh_assets_1["default"], { disabled: disableAssetsRefresh, withBackend: props.withBackend }))),
            react_1["default"].createElement(cell_1.Cell, { title: "Requests" },
                react_1["default"].createElement(Typography_1["default"], { className: classes.link },
                    react_1["default"].createElement(link_1["default"], { to: "https://app.nexys.io/app/request/crud", external: true }, "See all on Nexys.io")),
                react_1["default"].createElement(request_1["default"], __assign({}, props))),
            react_1["default"].createElement(cell_1.Cell, { title: "Email logs" },
                react_1["default"].createElement(cell_1.Layout, null,
                    react_1["default"].createElement(cell_1.Cell, { withPaper: false },
                        react_1["default"].createElement(Typography_1["default"], { className: classes.link },
                            react_1["default"].createElement(link_1["default"], { to: "https://app.nexys.io/app/email", external: true }, "See all on Nexys.io"))),
                    location.pathname !== sendEmailUrl && (react_1["default"].createElement(cell_1.Cell, { withPaper: false, classNames: { cell: classes.sendEmailButtonContainer } },
                        react_1["default"].createElement(button_default_1["default"], { label: "Send Email", target: sendEmailUrl, primary: true })))),
                react_1["default"].createElement(email_1["default"], __assign({}, props))),
            react_1["default"].createElement(cell_1.Cell, { title: "Workflows" },
                react_1["default"].createElement(Typography_1["default"], { className: classes.link },
                    react_1["default"].createElement(link_1["default"], { to: "https://app.nexys.io/app/workflow", external: true }, "See all on Nexys.io")),
                react_1["default"].createElement(workflow_1["default"], __assign({}, props))))));
};
exports["default"] = Dashboard;
